<template>
  <div class="main-content">
    <Nav style="margin-bottom:10px" />
    <div class="about">
      <div
        class="row"
        style="height:50px;justify-content: center;align-items: center;"
      >
        <div
          class="item-no line"
          style="justify-content: flex-end;align-items: center;"
        >
          <!-- <img
            src="../../assets/img/u385.svg"
            style="height: 10px;width: 10px;"
          /> -->
        </div>
        <div
          class="item-no"
          style="color: #fff;font-size: 48px;padding: 0 30px;font-weight:500;"
        >
          {{ $t("lang.about") }}
        </div>
        <div
          class="item-no line"
          style="justify-content: flex;align-items: center;"
        >
          <!-- <img
            src="../../assets/img/u385.svg"
            style="height: 10px;width: 10px;"
          /> -->
        </div>
      </div>
      <!--<p
        style="margin-top:20px;font-size:30px;font-weight:500;color:#fff;text-align:center"
      >
        About us
      </p>-->
    </div>

    <div class="center-body">
      <div class="row">
        <div class="item">
          <img src="../../assets/img/u380.png" style="width: 100%;" />
        </div>
        <div class="item">
          <div style="padding:42px 0 42px 42px;">
            <h2
              style="text-align:center;font-size:30px;color:#333;margin-bottom:30px"
            >
              {{ $t("lang.cmpintr") }}
            </h2>
            <p
              style="font-size:18px;color:#666;text-align: justify;line-height:28px;"
            >
              {{ $t("lang.aboutext1") }}
            </p>
          </div>
        </div>
      </div>
      <!-- <div
        class="row"
        style="color: #666;font-size: 18px;margin-top: 15px;padding: 0 25px;line-height: 2;"
      >
        {{ $t("lang.aboutext1") }}
      </div>
      <div class="row" style="padding: 25px;">
        <img src="../../assets/img/u380.png" style="width: 100%;" />
      </div>
      <div
        class="row"
        style="justify-content: center;align-items: center;margin-top: 25px;"
      >
        <div
          class="item-no line"
          style="justify-content: flex-end;align-items: center;"
        >
          <img
            src="../../assets/img/u385.svg"
            style="height: 10px;width: 10px;"
          />
        </div>
        <div
          class="item-no"
          style="color: #666;font-size: 18px;padding: 0 5px;"
        >
          {{ $t("lang.contactus") }}
        </div>
        <div
          class="item-no line"
          style="justify-content: flex;align-items: center;"
        >
          <img
            src="../../assets/img/u385.svg"
            style="height: 10px;width: 10px;"
          />
        </div>
      </div>

      <div
        class="col"
        style="margin-top: 15px;width: 100%;align-items: center;"
      >
        <span class="foot-text"
          >{{ $t("lang.add") }}：{{ $t("lang.addtext") }}</span
        >
        <span class="foot-text">{{ $t("lang.tel") }}：0086-021-54871771</span>
        <span class="foot-text">{{ $t("lang.fex") }}：0086-021-54871772</span>
        <span class="foot-text">E-mail：xinlong@china-cabletie.com</span>
      </div> -->
    </div>
    <div class="foot-box">
      <div
        class="row"
        style="width: 1200px; margin: auto; justify-content: space-between;"
      >
        <div class="col-no" style="margin-top: 15px;">
          <span
            style="
                color: ##2d2d2d;
                font-size: 30px;
                font-weight: 500;
                text-align: center;
                padding-bottom: 10px;
              "
            >{{ $t("lang.contactus") }}</span
          >
          <span class="foot-text"
            >{{ $t("lang.add") }}：{{ $t("lang.addtext") }}</span
          >
          <span class="foot-text">{{ $t("lang.tel") }}：0086-021-54871771</span>
          <span class="foot-text">{{ $t("lang.fex") }}：0086-021-54871772</span>
          <span class="foot-text">E-mail：xinlong@china-cabletie.com</span>
        </div>
        <div
          class="item-no"
          style="
              display: block;
              width: 350px;
              align-items: center;
              padding-top: 45px;
            "
        >
          <img
            src="../../assets/img/qrcode.png"
            style="display: block; width: 159px; height: 159px;"
          />
          <p style="margin-top: 32px; font-size: 20px; color: #2d2d2d;">
            {{ $t("lang.guanzhu") }}
          </p>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Nav from "./nav.vue";
export default {
  name: "App",
  components: {
    Nav,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.main-content {
  min-height: 100%;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  display: block;
  position: absolute;
  background: #fff;
  margin-top: 135px;
}
.center-body {
  width: 1200px;
  margin: 0 auto;
}
.about {
  width: 100%;
  min-width: 1200px;
  height: 300px;
  background-image: url("../../assets/img/about.png");
  background-size: cover;
  padding-top: 110px;
  margin-bottom: 40px;
}
.line {
  height: 3px;
  width: 132px;
  background: #e6e6e6;
}
/* .foot-text {
  font-size: 16px;
  line-height: 2;
} */
.foot-box {
  /* height: 211px; */
  width: 100%;
  background-color: #f0f0f0;
  justify-content: space-between;
  margin-top: 45px;
  padding: 15px 30px;
}
.foot-text {
  color: #2d2d2d;
  font-size: 20px;
  margin-top: 20px;
}
</style>
